import { useCallback, useEffect, useRef, useState } from 'react';
import apiService from '../services/api';

/**
 * Compteur de réservations table en attente de validation (polling).
 */
export function useTableReservationsPendingCount(commercantId, enabled = true) {
  const [pendingCount, setPendingCount] = useState(0);
  const intervalRef = useRef(null);

  const fetchCount = useCallback(async () => {
    if (!commercantId || !enabled) return;
    try {
      const data = await apiService.getTableReservationsPendingCount(commercantId);
      setPendingCount(Number(data?.count) || 0);
    } catch {
      // Silencieux — badge optionnel
    }
  }, [commercantId, enabled]);

  useEffect(() => {
    if (!commercantId || !enabled) {
      setPendingCount(0);
      return undefined;
    }

    fetchCount();
    intervalRef.current = setInterval(fetchCount, 15000);

    const onRefresh = () => fetchCount();
    window.addEventListener('clickorico:refresh-table-reservations', onRefresh);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      window.removeEventListener('clickorico:refresh-table-reservations', onRefresh);
    };
  }, [commercantId, enabled, fetchCount]);

  return { pendingCount, refresh: fetchCount };
}
